const aaa = [
	{
		path: "addhuodong",
		component: () => import("@/views/huodong/addhuodong.vue"),
		meta:{title:'活动管理'},
	},
	{
		path: "huodongList",
		component: () => import("@/views/huodong/huodongList.vue"),
		meta:{title:'活动管理',keepAlive:true},
	},
	{
		path: "cardList",
		component: () => import("@/views/huodong/cardList.vue"),
		meta:{title:'现金卡活动'},
	},
]
export default aaa;